<template lang="pug">
.sales-by-panel-grouped
  v-progress-linear.mb-2(v-if="isFetching" indeterminate height="4")
  template(v-for="(group, groupIndex) in groups")
    .yz-heading-9.text-neutral-700.mb-2(:key="`title-${group.panelName}`" :class="[groupIndex === 0 ? 'mt-2' : 'mt-8']") {{ group.panelName }}
    .panel-table-wrapper.mb-2(:key="`table-${group.panelName}`")
      yz-data-table(:radius="0" :headers="headers" :items="group.rowsWithSubtotal" item-key="id" disable-sort hide-default-footer :item-class="rowClass")
        template(v-slot:item.staff_details="{ item }")
          template(v-if="!item._isSubtotal")
            .yz-regular-body-xs.font-medium {{ item.staff_name || '-' }}
            .d-flex.align-center.mt-1(v-if="item.staff_ic || item.relationship")
              .yz-regular-body-xs.text-neutral-500.mr-1(v-if="item.staff_ic") {{ item.staff_ic }}
              yz-badge(v-if="item.relationship" border border-color="#0C6DFF" radius="12px" text-color="#0C6DFF" height="16px")
                span.yz-medium-body-2xs {{ item.relationship }}
        template(v-slot:item.patient_details="{ item }")
          template(v-if="!item._isSubtotal")
            .yz-regular-body-xs.font-medium {{ item.patient_name || '-' }}
            .yz-regular-body-xs.text-neutral-500(v-if="item.patient_ic") {{ item.patient_ic }}
            .yz-regular-body-xs.text-neutral-500(v-if="item.chit_no") Chit no.: {{ item.chit_no }}
</template>

<script>
export default {
  props: {
    headers: { type: Array, required: true },
    invoices: { type: Array, required: true },
    panelTotals: { type: Array, default: () => [] },
    isFetching: { type: Boolean, default: false }
  },
  computed: {
    totalRow () {
      if (!this.invoices.length) return null
      const last = this.invoices[this.invoices.length - 1]
      return last && last._isTotal ? last : null
    },
    dataRows () {
      return this.totalRow ? this.invoices.slice(0, -1) : this.invoices
    },
    panelTotalsByName () {
      const map = {}
      this.panelTotals.forEach(p => { map[p.name] = p })
      return map
    },
    groups () {
      const groups = []
      let current = null
      this.dataRows.forEach(row => {
        if (!current || current.panelName !== row.panel_name) {
          current = { panelName: row.panel_name, rows: [] }
          groups.push(current)
        }
        current.rows.push({ ...row, runningNumber: current.rows.length + 1 })
      })
      return groups.map(g => {
        const subtotal = this.panelTotalsByName[g.panelName]
        const rowsWithSubtotal = subtotal
          ? [...g.rows, { ...subtotal, id: `subtotal-${g.panelName}`, _isSubtotal: true }]
          : g.rows
        return { ...g, rowsWithSubtotal }
      })
    },
  },
  methods: {
    rowClass (item) {
      return item && item._isSubtotal ? 'panel-subtotal-row' : ''
    }
  }
}
</script>

<style scoped>
.panel-table-wrapper ::v-deep .v-data-table {
  border-left-color: transparent !important;
  border-right-color: transparent !important;
}

.panel-table-wrapper ::v-deep tbody tr td {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}

.panel-table-wrapper ::v-deep tr.panel-subtotal-row td {
  border-top: 1px solid black !important;
}
</style>
